import { Component, inject } from '@angular/core';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'ism-tutorial-menu',
  templateUrl: './tutorial-menu.component.html',
  standalone: false,
})
export class TutorialMenuComponent {
  session = inject(SessionService);

}
